import { LogIn } from "lucide-react";
import { useInRouterContext, useLocation } from "react-router";
import { returnToPath } from "@/lib/auth-return";

/**
 * #3398: a read answered 401, so the session has ended. Retrying sends the
 * same missing cookie, so the only useful step is signing in, and the link
 * brings the reader back to this page through the same returnTo path
 * RequireAuth and Landing use. A plain anchor, not a router Link: the full
 * load makes the session check start fresh instead of trusting a cached one.
 */
export function SignInAgain() {
  return useInRouterContext() ? <RoutedSignInAgain /> : <SignInNote here={windowHere()} />;
}

function RoutedSignInAgain() {
  const { pathname, search, hash } = useLocation();
  return <SignInNote here={`${pathname}${search}${hash}`} />;
}

function windowHere(): string {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function SignInNote({ here }: { here: string }) {
  return (
    <div
      role="status"
      data-testid="sign-in-again"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-border bg-muted/40 px-3 py-2 text-sm"
    >
      <LogIn className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
      <span className="min-w-0 flex-1 font-medium text-foreground">Your sign-in has expired.</span>
      <a
        href={returnToPath("/login", here)}
        className="inline-flex items-center rounded-md border border-input bg-background px-2.5 py-1 text-xs font-medium text-foreground hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        Sign in
      </a>
    </div>
  );
}
